<template>

  <div>

    <div v-if="!isPreForm">
      <b>{{selectedSubsidiary.title}}</b> / <b>{{selectedGroup.title}}</b><br/>
      <div v-if="selectedDate" class="mb-3">{{selectedDate.date | moment('dddd, DD. MMMM YYYY')}} um {{selectedDate.date | moment('HH:mm')}} Uhr</div>
      {{ settings['appointmentgroup.default.frontend.heading.form'].value }}
      <hr/>
    </div>

    <div v-for="formelement in form" :key="formelement.key">

      <div :key="formValidateCount">

        <b-form-group
            v-if="formelement.type === 'input'"
            label-cols-sm="6"
            label-cols-lg="6"
            :name="formelement.key"
            :label="formelement.label"
            :state="formStates[formelement.key]"
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            :validated="formStates[formelement.key]"
        >
          <b-form-input @update="validateFormelement(formelement)" v-model="userInput[formelement.key]" trim></b-form-input>
        </b-form-group>

        <b-form-group
            v-if="formelement.type === 'email'"
            label-cols-sm="6"
            label-cols-lg="6"
            :name="formelement.key"
            :label="formelement.label"
            :state="formStates[formelement.key]"
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            :validated="formStates[formelement.key]"
        >
          <b-form-input @input="validateFormelement(formelement)" v-model="userInput[formelement.key]" trim></b-form-input>
        </b-form-group>

        <b-form-group
            v-if="formelement.type === 'textarea'"
            label-cols-sm="6"
            label-cols-lg="6"
            :name="formelement.key"
            :label="formelement.label"
            :state="formStates[formelement.key]"
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            :validated="formStates[formelement.key]"
        >
          <b-form-textarea @input="validateFormelement(formelement)" v-model="userInput[formelement.key]"></b-form-textarea>
        </b-form-group>

        <div class="mt-3 form-html-content" v-if="formelement.type === 'html'" v-html="formelement.config.content">
        </div>

        <b-form-group
            v-if="!isPreForm && formelement.type === 'select' && (!formelement.config.has_appointment_filter || formelement.config.has_appointment_filter == 'false')"
            label-cols-sm="6"
            label-cols-lg="6"
            :name="formelement.key"
            :label="formelement.label"
            :state="formStates[formelement.key]"
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
        >
          <b-form-radio-group
              v-model="userInput[formelement.key]"
              :options="formelement.config.options"
              @input="validateFormelement(formelement)"
              value-field="content"
              text-field="label"
              stacked
          ></b-form-radio-group>

          <div class="mt-3" v-if="userInput[formelement.key]" v-html="nl2br(userInput[formelement.key])">
          </div>
        </b-form-group>


        <b-row v-if="isPreForm && formelement.type === 'select'  && formelement.config.has_appointment_filter">
          <b-col cols="12" md="6">
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="12"
                :name="formelement.key"
                :label="formelement.label"
                :state="formStates[formelement.key]"
                :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            >
              <b-form-radio-group
                  v-model="userInput[formelement.key]"
                  :options="formelement.config.options"
                  @input="validateFormelement(formelement)"
                  value-field="content"
                  text-field="label"
                  stacked
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <div v-if="userInput[formelement.key]" v-html="nl2br(userInput[formelement.key])"></div>
          </b-col>
        </b-row>

        <b-form-checkbox
            class="mt-3"
            size="xl"
            v-model="userInput[formelement.key]"
            :name="formelement.key"
            v-if="formelement.type === 'checkbox'"
            :state="formStates[formelement.key]"
            unchecked-value=""
            :invalid-feedback="formInvalidFeedback(formelement.type, formelement.key)"
            @input="validateFormelement(formelement)">{{formelement.label}}</b-form-checkbox>

      </div>

    </div>

  </div>

</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormRadioGroup,
  BFormTextarea,
  BRow,
  BCol
} from 'bootstrap-vue'

export default {
  name: "CustomerForm",
  components: {
    'b-row': BRow,
    'b-col': BCol,
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput,
    'b-form-radio-group': BFormRadioGroup,
    'b-form-checkbox': BFormCheckbox,
    'b-form-textarea': BFormTextarea,
  },
  props: ['settings', 'form', 'selectedDate', 'selectedSubsidiary', 'selectedGroup', 'isPreForm'],
  data () {
    return {
      userInput: {},
      formStates: {},
      formRules: {},
      formValidateCount: 0,
      formInvidualInvalidFeedback: []
    }
  },
  mounted() {
  },
  methods: {
    formInvalidFeedback(type, key) {
      if(key && this.formInvidualInvalidFeedback[key]) return this.formInvidualInvalidFeedback[key]
      if(type == 'input' || type == 'textarea') return 'Bitte füllen Sie dieses Feld aus'
      if(type == 'email') return 'Bitte geben Sie hier eine gültige E-Mail Adresse ein'
      if(type == 'select') return 'Bitte wählen Sie eine Option'
      if(type == 'checkbox') return 'Bitte bestätigen Sie dieses Feld'
    },
    reset () {
      this.userInput = {}
      this.formStates = {}
    },
    validate () {

      let formIsValid = true

      for(const formelement of this.form) {
        if (formelement.key !== 'form_captcha' && !this.validateFormelement(formelement)) formIsValid = false
      }
      this.formValidateCount++

      return {
        userInput: this.userInput,
        isValid: formIsValid
      }

    },
    validateFormelement(formelement) {

      let validInput = true
      let validInputOverwrite = null
      this.groupFilterFromPreForm = []

      if (formelement && formelement.config.validation_rules && formelement.config.validation_rules.indexOf('required') >= 0) {

        if (!this.userInput[formelement.key]) {
          validInput = false
        } else if (formelement.type === 'email') {
          const re = /\S+@\S+\.\S+/;
          validInput = re.test(this.userInput[formelement.key]);
        } else if (formelement.type === 'input' || formelement.type === 'textarea') {
          validInput = (this.userInput[formelement.key].length >= 3)
        } else if (formelement.type === 'checkbox') {
          validInput = this.userInput[formelement.key]
        }

      }

      if (formelement && formelement.config.validation_content && this.userInput[formelement.key] && this.userInput[formelement.key].length >= 3) {

        const result = new RegExp(formelement.config.validation_content.expression, 'gi').test(this.userInput[formelement.key].trim())
        console.log(result)
        if(validInput) {
          validInput = formelement.config.validation_content.type == 'allow' ? result : !result
        }
        if(!validInput && formelement.config.validation_content.message != '') {
          this.formInvidualInvalidFeedback[formelement.key] = formelement.config.validation_content.message
        }
        if(validInput && this.formInvidualInvalidFeedback[formelement.key]) delete this.formInvidualInvalidFeedback[formelement.key]
        if(!validInput && formelement.config.validation_content.continue) validInputOverwrite = true

      }

      this.formStates[formelement.key] = validInput

      if (formelement && formelement.type === 'select') {

        let formelementLabel = null
        for (const element of this.form) {
          if (element.key === formelement.key && element.config.options.length > 0) {
            for (const option of element.config.options) {
              if (option.content === this.userInput[formelement.key]) {
                formelementLabel = option.label
                if (formelement.config.has_appointment_filter && formelement.config.has_appointment_filter == 'true') {
                  if (option.appointment_filter && option.appointment_filter.length > 0) this.groupFilterFromPreForm = option.appointment_filter
                }
                break
              }
            }
          }
        }

        if (formelementLabel) this.userInput[formelement.key + ':label'] = formelementLabel
      }

      return validInputOverwrite ? validInputOverwrite : validInput
    },
    setErrors(errors) {

      for (let field in this.formStates) {
        this.formStates[field] = true
      }

      for (let error of errors) {
        this.formStates[error.field] = false
      }

      this.formValidateCount++

    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
  }
}
</script>

<style scoped>

</style>